// extracted by mini-css-extract-plugin
export default {"content-wrapper":"Transfer_content-wrapper__iVFEv","content-container":"Transfer_content-container__JooOx","transfer-text":"Transfer_transfer-text__Rpba7"};